import { UseMutationOptions, useQueryClient } from '@tanstack/react-query';
import useAppMutation from 'hooks/useAppMutation';
import { BaseErrorResponse } from 'models/_base';
import {
  MessageLogResendPayload,
  ResendMessageLogResponseTO,
} from 'models/automation/MessageLogs';
import API from 'services/API';
import { MESSAGE_LOGS_BASE_QUERY_KEY } from './messageLogsQuery';

type ResendMessageLogMutationArgs = MessageLogResendPayload & {
  messageLogUid: string;
};

type ReactQueryMutationOptions = Omit<
  UseMutationOptions<
    ResendMessageLogResponseTO,
    BaseErrorResponse,
    ResendMessageLogMutationArgs
  >,
  'mutationFn' | 'mutationKey'
>;

const resendMessageLog = ({
  messageLogUid,
  ...payload
}: ResendMessageLogMutationArgs) => {
  return API.post<ResendMessageLogResponseTO, BaseErrorResponse>(
    `/api/internal/trigger-logs/resend/${messageLogUid}`,
    payload,
  );
};

const useResendMessageLogMutation = ({
  onSuccess,
  ...options
}: ReactQueryMutationOptions = {}) => {
  const queryClient = useQueryClient();

  return useAppMutation({
    mutationFn: resendMessageLog,
    onSuccess: (...args) => {
      queryClient.invalidateQueries([MESSAGE_LOGS_BASE_QUERY_KEY]);
      return onSuccess?.(...args);
    },
    ...options,
  });
};

export default useResendMessageLogMutation;
